export default {
    props: {
        schemaModel: {
            type: Object,
            kComposite: 'schema.model'
        }, 
        schemaTimezone: {
            type: String,
            kComposite: 'schema.timezone'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoSchedulerDataSource/Schema.js